import { Injectable } from '@angular/core';

export const defaultNumberInputArrowedKey = [
    'Backspace',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    'Home',
    'End',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
];

@Injectable({ providedIn: 'root' })
export class KeyFilterSerivce {
    shouldPreventDefault(event: KeyboardEvent, allowedKeyList: string[]) {
        if (event.key.length === 1 && !allowedKeyList.includes(event.key) && !/^[0-9,]$/.test(event.key)) {
            return true;
        }

        return false;
    }
}
